module.exports = __webpack_public_path__ + "img/cover13.454345f8.png";